import qs from "qs";
import authAxios, { authHeader } from "./data";
import { ITaskUpdateRequest } from "../pages/Tasks/types";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/workTasks", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchOne = async (id: string, params: any) => {
  const response = await authAxios.get(`/api/workTasks/${id}`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const closeTask = async (id: string, req: any) => {
  const response = await authAxios.post(`/api/workTasks/${id}/close`, req, {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (id: string, req: ITaskUpdateRequest) => {
  const response = await authAxios.put(`/api/workTasks/${id}`, req, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get("/api/workTasks/count", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchHasNotifications = async () => {
  const response = await authAxios.get("/api/workTasks/hasUnprocessed", {
    headers: authHeader(),
  });

  return response.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(`/api/workTasks/${id}/download`, {
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const WorkTasksService = {
  fetchAll,
  fetchCount,
  fetchOne,
  closeTask,
  update,
  fetchHasNotifications,
  download,
};

export default WorkTasksService;
